import React, { Fragment } from 'react'
import {
  DesignTokens,
  Frame,
  SpacerVertical,
  Typography,
} from '@klarna/bubble-ui'
import PaymentMethod from '../PaymentMethod/PaymentMethod'
import InstallmentPaymentDetails from '../PaymentMethodDetails/InstallmentPaymentDetails'
import InvoicePaymentDetails from '../PaymentMethodDetails/InvoicePaymentDetails'
import isAnyValueEmpty from '../../utilities/isAnyValueEmpty'
import { PaymentDetailsProps } from '../../types'
import { paymentMethodContainerCss, tokenizationSnippetCss } from '../css'

export type PaymentMethodProps = {
  badge: string
  purchaseAmount: string
  backgroundColorKey: string
  frequencyTitle?: string
  installmentAmount?: string
  snippet?: string
}

type PaymentMethodContainerProps = {
  heading?: string
  frameBackground: string
  paymentMethodProps?: PaymentMethodProps
  paymentDetailsProps?: PaymentDetailsProps
  isSubscriptionOrAddToWallet?: boolean
};

const PaymentMethodContainer: React.FC<PaymentMethodContainerProps> = ({
  frameBackground = 'colors/borders/subtle-surface',
  paymentMethodProps = null,
  paymentDetailsProps = null,
  isSubscriptionOrAddToWallet = false
}) => {
  const designContext = DesignTokens.useDesignContext()
  const hasAllPaymentProps = !isAnyValueEmpty(paymentMethodProps, ['snippet'])
  const willShowTokenizationSnippet = paymentDetailsProps?.type === 'installment'
  && paymentMethodProps.snippet
  && isSubscriptionOrAddToWallet
  const isInvoiceAndMissingTotalValue = paymentDetailsProps?.type === 'invoice' && paymentDetailsProps?.totalAmount === 'null'

  const shouldDisplayPM = hasAllPaymentProps && !isInvoiceAndMissingTotalValue

  return (
    <Fragment>
      { shouldDisplayPM ? (
        <Fragment>
          <Frame
            UNSAFE_props={{
              role: 'listitem'
            }}
            UNSAFE_style={paymentMethodContainerCss(designContext, frameBackground, willShowTokenizationSnippet)}>
            <PaymentMethod {...paymentMethodProps} isSubscriptionOrAddToWallet={isSubscriptionOrAddToWallet} />
            {!isSubscriptionOrAddToWallet && paymentDetailsProps && (() => {
              switch (paymentDetailsProps.type) {
                case 'fisc':
                case 'installment':
                  return <InstallmentPaymentDetails {...paymentDetailsProps} />
                case 'payByCard':
                case 'invoice':
                  return <InvoicePaymentDetails {...paymentDetailsProps} />
                default: {
                  // TypeScript will catch this at compile time if we add new types
                  throw new Error(`Unhandled payment details type: ${(paymentDetailsProps as any).type}`)
                }
              }
            })()}

          </Frame>
          { willShowTokenizationSnippet && (
            <Frame
              backgroundColorToken="colors/backgrounds/subtle-inline"
              paddingToken="space.100"
              UNSAFE_style={tokenizationSnippetCss(designContext, frameBackground)}>
              <Typography textToken="text-style/text/paragraphs/default/regular"
                colorToken="colors/text/subtle">
                {paymentMethodProps.snippet}
              </Typography>
            </Frame>
          )}
          <SpacerVertical spaceToken="space.150" />
        </Fragment>
      ) : null }

    </Fragment>
  )
}

export default PaymentMethodContainer
